/**
 * Product Arrival Dates
 * Displays estimated arrival dates for backordered products
 * For use with the Gamma Powersports API (Proxy Version)
 */
document.addEventListener('DOMContentLoaded', function() {
  console.log('Product Arrival Dates: DOM Content Loaded event fired');

  window.addEventListener('error', function(event) {
    const scriptName = 'product-arrival-dates.js';
    if (event.error && event.error.stack && event.error.stack.includes(scriptName)) {
      console.error('Product Arrival Dates: Unhandled error caught by global handler:', event.error);
    }
  });

  const ProductArrivalDates = {
    config: {},
    elements: {
      container: document.getElementById('product-arrival-dates'),
      content: document.getElementById('arrival-dates-content'),
      loading: document.getElementById('arrival-dates-loading'),
      error: document.getElementById('arrival-dates-error'),
      noData: document.getElementById('arrival-dates-no-data')
    },
    state: { arrivalDates: [], hasLoaded: false, isLoading: false, hasError: false },

    init: function() {
      console.log('Product Arrival Dates: Initializing...');
      if (!this.elements.container) { console.warn('PA Dates: Container missing.'); return; }
      if (window.arrivalDatesConfig) { this.config = window.arrivalDatesConfig; console.log('PA Dates: Config loaded:', this.config); }
      else { console.warn('PA Dates: Config missing.'); this.showError(); return; }
      if (!this.config.productSku) { console.warn('PA Dates: Initial SKU missing.'); this.hideAllElements(); if (this.elements.container) this.elements.container.style.display = 'none'; return; }
      const isInStock = this.config.productInStock === true || this.config.productInStock === 'true';
      if (isInStock && !this.config.forceCheck) { console.log(`PA Dates: Skipping fetch for SKU ${this.config.productSku} (in stock).`); this.hideAllElements(); if (this.elements.container) this.elements.container.style.display = 'none'; return; }
      this.setupVariantListeners();
      this.loadArrivalDates();
    },

    setupVariantListeners: function() {
      console.log('PA Dates: Setting up variant listeners...');
      document.addEventListener('variant:changed', this.handleVariantChange.bind(this));
      document.addEventListener('product:variant:change', this.handleVariantChange.bind(this));
      const variantSelectors = document.querySelectorAll('select[name^="options"], input[type="radio"][name^="options"], form[action*="/cart/add"] select, form[action*="/cart/add"] input[type="radio"], [data-variant-selector], .single-option-selector, .variant-input');
      variantSelectors.forEach(selector => { selector.addEventListener('change', this.handleVariantSelectorChange.bind(this)); });
      console.log(`PA Dates: Attached 'change' listeners to ${variantSelectors.length} selectors.`);
    },

    handleVariantChange: function(event) {
      console.log('PA Dates: variant:changed event detected', event.detail);
      if (event.detail && event.detail.variant) {
        const { sku, available: isAvailable } = event.detail.variant;
        if (sku && sku !== this.config.productSku) {
          console.log(`PA Dates: Variant changed. New SKU: ${sku}, Available: ${isAvailable}`);
          this.config.productSku = sku; this.config.productInStock = isAvailable; this.loadArrivalDates();
        } else {
          console.log('PA Dates: Variant event, SKU same/missing.');
          if (typeof isAvailable !== 'undefined' && isAvailable !== this.config.productInStock) { this.config.productInStock = isAvailable; this.loadArrivalDates(); }
        }
      } else { console.log('PA Dates: Variant event missing details.'); this.handleVariantSelectorChange(); }
    },

    handleVariantSelectorChange: function() {
      console.log('PA Dates: Selector change detected. Scheduling check...');
      clearTimeout(this.selectorChangeTimeout);
      this.selectorChangeTimeout = setTimeout(() => {
        console.log('PA Dates: Executing scheduled check.');
        const newSku = this.getCurrentProductSku(); const isAvailable = this.isCurrentVariantAvailable();
        const skuChanged = newSku && newSku !== this.config.productSku;
        const availabilityChanged = typeof isAvailable !== 'undefined' && isAvailable !== this.config.productInStock;
        if (skuChanged || availabilityChanged) {
          console.log(`PA Dates: Selector change. New SKU: ${newSku} (${skuChanged}), Available: ${isAvailable} (${availabilityChanged})`);
          if (skuChanged) { this.config.productSku = newSku; } if (availabilityChanged) { this.config.productInStock = isAvailable; } this.loadArrivalDates();
        } else { console.log(`PA Dates: Selector change, no change detected.`); }
      }, 200);
    },

    getCurrentProductSku: function() { return this.config.productSku; },
    isCurrentVariantAvailable: function() { return this.config.productInStock; },

    showLoading: function() { 
      this.state.isLoading = true; 
      this.state.hasError = false; 
      this.hideAllElements(); 
      if (this.elements.loading) { 
        const isCompact = this.config.useCompactLayout === true || this.config.useCompactLayout === 'true';
        this.elements.loading.innerHTML = isCompact ? 
          `<div class="arrival-dates-skeleton-compact"><span class="arrival-dates-skeleton-bar" style="width: 80px;"></span><span class="arrival-dates-skeleton-bar" style="width: 120px;"></span></div>` :
          `<div class="arrival-dates-skeleton-standard"><div class="arrival-dates-skeleton-bar" style="width: 180px; height: 18px; margin-bottom: 12px;"></div><div class="arrival-dates-skeleton-bar" style="width: 100%; height: 36px; border-radius: 6px;"></div></div>`;
        this.elements.loading.style.display = 'block'; 
      } 
      if (this.elements.container) { 
        this.elements.container.setAttribute('data-state', 'loading'); 
        this.elements.container.style.display = 'block'; 
      } 
    },
    showError: function(message = 'Error loading arrival dates.') { 
      this.state.isLoading = false; 
      this.state.hasError = true; 
      this.hideAllElements(); 
      if (this.elements.error) { 
        this.elements.error.innerHTML = `
          <div class="arrival-dates-error-card">
            <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <circle cx="12" cy="12" r="10"></circle>
              <line x1="12" y1="8" x2="12" y2="12"></line>
              <line x1="12" y1="16" x2="12.01" y2="16"></line>
            </svg>
            <span>${this.sanitizeText(message)}</span>
          </div>
        `;
        this.elements.error.style.display = 'block'; 
      } 
      if (this.elements.container) { 
        this.elements.container.setAttribute('data-state', 'error'); 
        this.elements.container.style.display = 'block'; 
      } 
    },
    showNoData: function(message = 'No estimated arrival dates available.') { 
      this.state.isLoading = false; 
      this.state.hasError = false; 
      this.hideAllElements(); 
      if (this.elements.noData) { 
        const isCompact = this.config.useCompactLayout === true || this.config.useCompactLayout === 'true';
        if (isCompact) {
            this.elements.noData.innerHTML = `<span class="arrival-dates-subtle-empty">${this.sanitizeText(message)}</span>`;
        } else {
            this.elements.noData.innerHTML = `
              <div class="arrival-dates-empty-card">
                <svg viewBox="0 0 24 24" width="28" height="28" fill="none" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" style="color: color-mix(in srgb, rgba(var(--color-foreground)) 40%, transparent);">
                  <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                  <line x1="16" y1="2" x2="16" y2="6"></line>
                  <line x1="8" y1="2" x2="8" y2="6"></line>
                  <line x1="3" y1="10" x2="21" y2="10"></line>
                  <line x1="3" y1="3" x2="21" y2="21" stroke="rgba(var(--color-accent-1))" stroke-width="1.5"></line>
                </svg>
                <div class="arrival-dates-empty-title">No Upcoming Deliveries</div>
                <div class="arrival-dates-empty-text">There are currently no replenishment shipments scheduled for this item.</div>
              </div>
            `;
        }
        this.elements.noData.style.display = 'block'; 
      } 
      if (this.elements.container) { 
        this.elements.container.setAttribute('data-state', 'no-data'); 
        this.elements.container.style.display = 'block'; 
      } 
    },
    hideAllElements: function() { if (this.elements.loading) this.elements.loading.style.display = 'none'; if (this.elements.error) this.elements.error.style.display = 'none'; if (this.elements.noData) this.elements.noData.style.display = 'none'; if (this.elements.content) this.elements.content.style.display = 'none'; },

    loadArrivalDates: function() {
      const partNumber = this.config.productSku;
      const isInStock = this.config.productInStock === true || this.config.productInStock === 'true';
      if (isInStock && !this.config.forceCheck) { console.log(`PA Dates: Skipping fetch for SKU ${partNumber} (in stock).`); this.hideAllElements(); if (this.elements.container) this.elements.container.style.display = 'none'; return; }
      console.log(`PA Dates: Preparing to load data for SKU: ${partNumber}`);
      if (!partNumber || typeof partNumber !== 'string' || partNumber.trim() === '') { console.warn('PA Dates: Invalid SKU.'); this.showNoData('No SKU selected or available.'); return; }
      const apiBase = this.config.apiUrl || "https://gamma-proxy.dry-poetry-01bd.workers.dev";
      const apiUrl = `${apiBase}/inventory/getEstimatedArrivalsForItem`;
      const requestUrl = `${apiUrl}?partNumber=${encodeURIComponent(partNumber)}`;
      this.showLoading();
      console.log(`PA Dates: Making API request to ${requestUrl}`);

      fetch(requestUrl, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
      })
      .then(response => {
        console.log(`PA Dates: API response status: ${response.status}`);
        if (!response.ok) {
           if (response.status === 401) { return { error: { message: 'Authentication failed. Please check configuration.' }, status: 'error' }; } 
           if (response.status === 404) { console.warn(`PA Dates: API 404 or no data for SKU ${partNumber}.`); return null; }
           if (response.status >= 500) { return { error: { message: 'Server error encountered. Please try again later.' }, status: 'error' }; }
           const error = new Error(`API responded with status: ${response.status}`); error.response = response; throw error;
        }
        if (response.status === 204) { return null; }
        return response.text().then(text => { return text ? JSON.parse(text) : null; }); 
      })
      .then(data => {
        this.state.isLoading = false;

        if (data === null) {
            console.log(`PA Dates: No arrival data found for SKU ${partNumber} (API returned empty/null/404/204).`);
            this.showNoData();
            return;
        }

        if (data.status && typeof data.status === 'string' && data.status.toLowerCase() === 'success') {
            if (data.data && data.data.arrivalDates && Array.isArray(data.data.arrivalDates)) {
                const validDates = data.data.arrivalDates.filter(item => {
                    const qty = parseInt(item.qty, 10);
                    const isValidDate = item.eta && !isNaN(new Date(item.eta).getTime());
                    return isValidDate && !isNaN(qty) && qty > 0;
                });

               if (validDates.length > 0) {
                    const sortedValidDates = validDates.sort((a, b) => {
                        const dateA = new Date(a.eta || 0).getTime(); const dateB = new Date(b.eta || 0).getTime();
                        if (isNaN(dateA) && isNaN(dateB)) return 0; if (isNaN(dateA)) return 1; if (isNaN(dateB)) return -1;
                        return dateA - dateB;
                    });
                    this.state.arrivalDates = [sortedValidDates[0]]; // Keep only the first date
                    this.state.hasLoaded = true;
                    console.log(`PA Dates: Processed ${this.state.arrivalDates.length} earliest valid arrival date entry.`);
                    this.renderArrivalDates();
               } else {
                    console.log(`PA Dates: API status success, but no valid/future arrival dates found for SKU ${partNumber}.`);
                    this.showNoData();
               }
            } else {
              console.warn('PA Dates: API status success, but invalid data structure received:', data);
              this.showNoData();
            }
        } else {
            console.warn(`PA Dates: API status not 'success' or missing. Status: ${data.status}`, data);
            const errorMessage = (data.error && data.error.message) ? data.error.message : 'Failed to retrieve arrival dates.';
            if (typeof errorMessage === 'string' && errorMessage.toLowerCase() === 'success') {
                this.showNoData();
            } else {
                this.showError(errorMessage);
            }
        }
      })
      .catch(error => {
        console.error('PA Dates: Error fetching or processing arrival dates:', error);
        this.showError(error.response ? `API Error: ${error.message}` : 'Network error. Could not reach API.');
        this.state.isLoading = false;
      });
    },

    formatDate: function(dateString) { if (!dateString) return 'Date Unknown'; try { let d=dateString; if (d.includes('T') && !d.endsWith('Z') && !d.match(/([+-]\d{2}:\d{2})$/)) d+='Z'; else if (!d.includes('T')) { const p=d.split(/[-/]/); if (p.length===3) {const dt=new Date(p[0],p[1]-1,p[2]); if(!isNaN(dt.getTime())) return dt.toLocaleDateString(undefined,{year:'numeric',month:'long',day:'numeric',timeZone:'UTC'});}} const dt=new Date(d); if(isNaN(dt.getTime())) {console.warn(`PA Dates: Invalid date:"${dateString}"`); return dateString;} return dt.toLocaleDateString(undefined,{year:'numeric',month:'long',day:'numeric',timeZone:'UTC'}); } catch(e) {console.error(`PA Dates: Error formatting date "${dateString}":`,e); return dateString;} },
    getEtaTypeLabel: function(etaType) { 
      if (!etaType || typeof etaType !== 'string') return ''; 
      const tu = etaType.toUpperCase(); 
      const st = this.sanitizeText(etaType); 
      const cp = this.config.useCompactLayout ? 'arrival-dates-subtle__' : 'arrival-dates-'; 
      let lt = st; 
      let lc = 'unknown'; 
      let icon = '';
      switch (tu) {
        case 'CARGO':
          lt = this.config.labelCargo || 'Confirmed';
          lc = 'confirmed';
          icon = `<svg viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" style="margin-right: 4px; display: inline-block; vertical-align: middle;"><polyline points="20 6 9 17 4 12"></polyline></svg>`;
          break;
        case 'PO':
          lt = this.config.labelPO || 'Estimated';
          lc = 'estimated';
          icon = `<svg viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" style="margin-right: 4px; display: inline-block; vertical-align: middle;"><circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline></svg>`;
          break;
      } 
      return `<span class="${cp}type ${lc}">${icon}<span>${lt}</span></span>`; 
    },
    renderArrivalDates: function() { 
      console.log('PA Dates: Rendering...'); 
      if (!this.elements.content) { console.error('PA Dates: Content element missing.'); this.showError('Internal error.'); return; } 
      const d = this.state.arrivalDates; 
      if (!d || d.length === 0) { console.log('PA Dates: No dates.'); this.showNoData(); return; } 
      this.hideAllElements(); 
      
      this.elements.content.classList.remove('arrival-dates-fade-in');
      void this.elements.content.offsetWidth; // Trigger reflow
      this.elements.content.classList.add('arrival-dates-fade-in');

      if (this.config.useCompactLayout) { this.renderCompactLayout(d); } else { this.renderStandardLayout(d); } 
      this.elements.content.style.display = 'block'; 
      if (this.elements.container) { 
        this.elements.container.setAttribute('data-state', 'has-dates'); 
        this.elements.container.style.display = 'block'; 
      } 
      console.log('PA Dates: Render complete.'); 
    },
    renderStandardLayout: function(datesToRender) { console.log('PA Dates: Rendering standard.'); const t=this.config.titleStandard||'Estimated Arrival Dates'; let h=`<div class="arrival-dates-header"><h3 class="arrival-dates-title">${this.sanitizeText(t)}</h3></div><ul class="arrival-dates-list">`; datesToRender.forEach(i=>{h+=`<li class="arrival-date-item"><div class="arrival-date">${this.formatDate(i.eta)}</div><div class="arrival-qty">${this.sanitizeText(i.qty)} units</div><div class="arrival-status">${this.getEtaTypeLabel(i.etaType)}</div></li>`;}); h+='</ul>'; const n=this.config.noteStandard||'<strong>Note:</strong> Dates subject to change.'; if(n){h+=`<div class="arrival-dates-note"><p>${n}</p></div>`;} this.elements.content.innerHTML=h; },
    renderCompactLayout: function(datesToRender) { console.log('PA Dates: Rendering compact.'); const t=this.config.titleCompact||'Expected Arrival:'; const n=this.config.noteCompact||'Dates subject to change.'; let h=`<div class="arrival-dates-subtle__title">${this.sanitizeText(t)}</div><ul class="arrival-dates-subtle__list">`; datesToRender.forEach(i=>{h+=`<li class="arrival-dates-subtle__item"><div class="arrival-dates-subtle__date">${this.formatDate(i.eta)}</div><div class="arrival-dates-subtle__qty">(${this.sanitizeText(i.qty)})</div><div class="arrival-dates-subtle__status">${this.getEtaTypeLabel(i.etaType)}</div></li>`;}); h+='</ul>'; if(n){h+=`<div class="arrival-dates-subtle__note">${this.sanitizeText(n)}</div>`;} this.elements.content.innerHTML=h; },
    sanitizeText: function(str) { if(this.config.skipSanitization===true){return String(str);} if(str===null||typeof str==='undefined')return ''; const d=document.createElement('div'); d.textContent=str; return d.innerHTML; },
    
    testApiConnection: function() { 
      if(!this.config.enableApiDiagnostics){console.warn('PA Dates (Diagnostics): Disabled.'); return;} 
      const b=this.config.apiUrl||"https://gamma-proxy.dry-poetry-01bd.workers.dev"; 
      const t=`${b}/account/getShipTos`; 
      console.log('PA Dates (Diagnostics): Testing API...'); alert('Running Diags...\nCheck console (F12).'); 
      console.log(`Diag 1: Fetch to ${t}`); 
      
      fetch(t,{method:'GET',headers:{'Accept':'application/json'}})
      .then(r=>{console.log(`Test 1: Status ${r.status} (${r.ok?'OK':'Error'})`); alert(`API Test 1 ${r.ok?'Passed':'Failed'}:\nStatus: ${r.status}\nCheck console.`);})
      .catch(e=>{console.error('Test 1 Error:',e); alert(`API Test 1 Failed:\nError: ${e.message}\nCheck console.`);}); 
      
      const p=this.config.productSku; 
      if(p){
        const a=`${b}/inventory/getEstimatedArrivalsForItem?partNumber=${encodeURIComponent(p)}`; 
        console.log(`Diag 2: Fetch arrivals for SKU ${p}`); 
        fetch(a,{method:'GET',headers:{'Accept':'application/json'}})
        .then(r=>{console.log(`Test 2: Status ${r.status} (${r.ok?'OK':'Error'})`); alert(`API Test 2 ${r.ok?'Passed':'Failed'} (Arrival):\nStatus: ${r.status}\nCheck console.`); return r.ok?r.json():null;})
        .then(d=>{if(d){console.log('Test 2 Data:',d);}})
        .catch(e=>{console.error('Test 2 Error:',e); alert(`API Test 2 Failed (Arrival):\nError: ${e.message}\nCheck console.`);});
      } else {console.warn('Test 2 Skipped: No SKU.'); alert('API Test 2 Skipped: No SKU.');} 
    }
  };

  // --- Initialization ---
  try {
    console.log('PA Dates: Starting initialization...');
    ProductArrivalDates.init();
    window.ProductArrivalDates = ProductArrivalDates;
    console.log('PA Dates: Initialization complete.');
  } catch (error) {
    console.error('PA Dates: Critical init error:', error);
    if (typeof ProductArrivalDates !== 'undefined' && typeof ProductArrivalDates.showError === 'function') { ProductArrivalDates.showError('Critical error during setup.'); }
    else { const el=document.getElementById('arrival-dates-error'); if(el){el.textContent='Critical error.'; el.style.display='block';} const c=document.getElementById('product-arrival-dates'); if(c){c.setAttribute('data-state','error'); c.style.display='block';} }
  }
});